import { CriticalPoint, PracticePath } from "src/app/classes/model/practice-path";

export const cachedPracticePathFields = [ "uuid", "name" ] as const;

export type CachedPracticePath = Pick<PracticePath, typeof cachedPracticePathFields[number]>;

export type CachedCriticalPointFields = CriticalPoint;